export enum PeriodsAgo {
  week = "week",
  month = "month",
  threeMonths = "threeMonths",
  sixMonths = "sixMonths",
  year = "year",
  threeYears = "threeYears",
  custom = "custom"
}

export enum SortDirection {
  ASC = "asc",
  DESC = "desc"
}
